<template>
  <div class="dialog">
    <div>
      <van-overlay :show="infoShow">
        <div class="dialog_box">
          <img
            src="@/assets/images/cartoon-kid/close.png"
            @click="goback"
            class="dialog_box_close"
          />
          <div class="main">
            <p v-if="infoTitle" class="title">{{ infoTitle }}</p>
            <p class="msg" :style="{ marginTop: infoTitle ? '12px' : '28px' }">
              {{ infoMsg }}
            </p>
          </div>
          <div v-if="!cancelMsg" class="next" @click="next">{{ sureMsg }}</div>
          <div v-else class="butBox">
            <div class="butBox_left" @click="cance">{{ cancelMsg }}</div>
            <div class="butBox_right" @click="next">{{ sureMsg }}</div>
          </div>
        </div>
      </van-overlay>
    </div>
  </div>
</template>
<script>
export default {
  name: "dialog-box",
  props: ["infoShow", "infoMsg", "infoTitle", "cancelMsg", "sureMsg"],
  data() {
    return {};
  },
  methods: {
    goback() {
      this.$emit("goback");
    },
    next() {
      if (!this.cancelMsg) {
        this.$emit("next", 1);
      } else {
        this.$emit("next", 2);
      }
    },
    cance() {
      if (!this.cancelMsg) {
        this.$emit("cance", 1);
      } else {
        this.$emit("cance", 2);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.van-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  .dialog_box {
    width: 270px;
    padding-bottom: 20px;
    background: #ffffff;
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    .dialog_box_close {
      position: absolute;
      right: 10px;
      top: 10px;
      height: 22px;
      width: 22px;
    }
    .main {
      margin-top: 20px;
      p {
        text-align: center;
      }
      .title {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #2e4344;
      }
      .msg {
        width: 190px;
        margin-left: 40px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #626a6b;
        margin-bottom: 16px;
      }
    }
    .next {
      width: 164px;
      height: 40px;
      background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
      border-radius: 20px;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      margin-left: 53px;
    }
    .butBox {
      display: flex;
      justify-content: center;
      .butBox_left {
        width: 110px;
        height: 40px;
        background: #949c9d;
        border-radius: 20px;
        opacity: 0.49;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        margin-right: 12px;
      }
      .butBox_right {
        text-align: center;
        line-height: 40px;
        width: 110px;
        height: 40px;
        background: linear-gradient(180deg, #17e1eb 0%, #24bffb 100%);
        border-radius: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
  }
}
</style>
